import type { LayoutRuntime } from "../../../../shared/layouts/registry";

export const teamDetailDefaultLayout: LayoutRuntime = {
  feature: "team-detail",
  layout: "default",
  rootClass: "gwd-livescore-layout--default",
};
